<template>

    <div id="app">

        <!-- remove again -->
        <!-- <div v-if="debuggingSet"> -->

            <component :is="style">
                @import url('https://fonts.googleapis.com/css?family={{googleFontsToLoad}}');
            </component>
            
            <Topbar />

            <Sidebar />

            <SidebarSettings v-if="settingsFromWeebly.showSettingsBar" />

            <b-container class="global-container" fluid :class="settingsFromWeebly.showSettingsBar ? 'sidebar-settings-opened' : ''">

                <component :is="settingsFromWeebly.weeblySettings.name"></component>


            </b-container>
            
            <!-- modal windows -->

            <font-picker-modal />

            <font-library-client-modal />

            <my-account-modal-element />

            <notifications-modal />

            <upgrade-modal />

            <tos-modal />


        <!-- </div> -->


    </div>

</template>

<script>
import axios from 'axios'

// layout
import Topbar from './components/layout/Topbar'
import Sidebar from './components/layout/Sidebar'
import SidebarSettings from './components/layout/SidebarSettings'

// select element component
import SelectElements from './components/SelectElements'

// my account modal
import MyAccount from './components/MyAccount'

// notifications modal
import Notifications from './components/Notifications'

// upgrade modal
import UpgradeAccount from './components/UpgradeAccount'

// tos modal
import Tos from './components/Tos'



// elements components
import Button from './components/elements/Button'
import Blocks from './components/elements/Blocks'
import VerticalDivider from './components/elements/VerticalDivider'
import HorizontalDivider from './components/elements/HorizontalDivider'
import LightBox from './components/elements/LightBox'
import Accordion from './components/elements/Accordion'
import Anchor from './components/elements/Anchor'
import ContentSlider from './components/elements/ContentSlider'
import TestimonialSlider from './components/elements/TestimonialSlider'
import ImageSlider from './components/elements/ImageSlider'
import ContentSliderCarousel from './components/elements/ContentSliderCarousel'
import AnimateOnScroll from './components/elements/AnimateOnScroll'
import Blogcards from './components/elements/Blogcards'
import BlogcardsSlider from './components/elements/BlogcardsSlider'
import Pricingtables from './components/elements/Pricingtables'
import Title from './components/elements/Title'

// font picker
import FontPicker from './components/elements/elementSettings/Fontpicker'

// client font library
import FontLibraryClient from './components/elements/elementSettings/FontLibraryClient'


export default {

    name: 'App',

    components: {

        // layout
        Topbar,
        Sidebar,
        SidebarSettings,

        // select elements panel
        SelectElements,

        // elements
        Button,
        Blocks,
        HorizontalDivider,
        VerticalDivider,
        LightBox,
        Accordion,
        Anchor,
        ContentSlider,
        AnimateOnScroll,
        ContentSliderCarousel,
        ImageSlider,
        TestimonialSlider,
        Blogcards,
        BlogcardsSlider,
        Pricingtables,
        Title,

        // font picker
        'font-picker-modal' : FontPicker,
        'font-library-client-modal' : FontLibraryClient,

        // my account modal
        'my-account-modal-element': MyAccount,

        // notifications modal
        'notifications-modal': Notifications,

        // upagrade modal
        'upgrade-modal': UpgradeAccount,

        // tos modal
        'tos-modal': Tos
        
    },

    methods: {

    },

    data() {
        return {
            debuggingSet: false,
            style: 'style'
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state
        },

        googleFontsToLoad() {
            var allGFonts = this.$store.state.googleFontsToLoad
            var gFonts = allGFonts.toString()
            if(allGFonts.length > 0){
                gFonts = gFonts.replace(/,/g, '|');

            } 
            return gFonts
        },
        clientPro() {
            return this.$store.state.clientInfo.clientAccount
        }
        
        

    },

    beforeCreate() {
        // getQueryStringValue:  (link, key) => {  
        //     return decodeURIComponent(window.location.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent('jwt').replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
        // } 
        // getQueryStringValue(link, "data-popup")
        let fd = new FormData();
        let jwtToken = function findGetParameter() {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === 'jwt') result = decodeURIComponent(tmp[1]);
                });
            return result;
        }
        this.$store.state.jwtToken = jwtToken()

        fd.append('jwt-token', this.$store.state.jwtToken)
        
        axios.post('https://www.appjustable.com/weebly/app_in_process/buttons/user_info.php',fd)
        .then((response)=> {
            console.log(response)
            this.$store.state.googleFontsToLoad = response.data.fonts

            this.$store.state.clientInfo.clientEmail = response.data.email

            this.$store.state.clientInfo.clientAccount = response.data.account_type

            this.$store.state.clientInfo.clientActivationCode = response.data.activation_code

            this.$store.state.clientInfo.clientSitesAmountAllowed = response.data.account_licenses

            this.$store.state.clientInfo.clientSitesUsedOn = response.data.sites.length


        }).catch( (error)=> {
            console.log(error)
        })
    },

    mounted() {


		window.addEventListener( "message", (event) => {
           
           

           if( event.origin !== 'https://www.youtube.com' ){ 

               console.log('event.origin: ',event.origin)
                console.log('event.data: ',event.data)

                window.frameOrigin = event.origin;
                var weeblyMessage = event.data;

                // get Weebly settings
                if(weeblyMessage.action == "settings:load"){

                    console.log("Got settings!")
                    console.log(weeblyMessage.data)
                    this.$store.state.weeblySettings.name = weeblyMessage.data.settings.elementName
                    this.$store.state.weeblySettings.html = weeblyMessage.data.settings.html_output
                    this.$store.state.weeblySettings.settings = JSON.parse(weeblyMessage.data.settings.settingsOutput)

                    // set user site and element id in store
                    this.$store.state.elementIdWeebly = weeblyMessage.data.config.element_id
                    this.$store.state.userIdWeebly = weeblyMessage.data.config.user_id
                    this.$store.state.siteIdWeebly = weeblyMessage.data.config.site_id

                }

                if(weeblyMessage.action == "settings:updated"){
                    console.log('overlay removed from App.vue, settings for Weebly were updated')
                    this.$store.state.savingOverlay = false
                }
           }

        })


        

    }
    
}
</script>

<style lang="less">

@import 'bootstrap/dist/css/bootstrap.css';

@import 'bootstrap-vue/dist/bootstrap-vue.css';

@import './less/colors.less';

// @font-face {
//     font-family: 'Dashboard UI';
//     src: url('./assets/fonts/Dashboard-UI-Semi.woff2') format('woff2'),
//         url('./assets/fonts/Dashboard-UI-Semi.woff') format('woff');
//     font-weight: 700;
//     font-style: normal;
// }

// @font-face {
//     font-family: 'Dashboard UI';
//     src: url('./assets/fonts/Dashboard-UI-Regular.woff2') format('woff2'),
//         url('./assets/fonts/Dashboard-UI-Regular.woff') format('woff');
//     font-weight: 400;
//     font-style: normal;
// }

@font-face {
    font-family: 'Dashboard UI';
    src: url('./assets/fonts/ui-db-ff-bold.woff2') format('woff2'),
        url('./assets/fonts/ui-db-ff-bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
}

@font-face {
    font-family: 'Dashboard UI';
    src: url('./assets/fonts/ui-db-ff-reg.woff2') format('woff2'),
        url('./assets/fonts/ui-db-ff-reg.woff') format('woff');
    font-weight: 400;
    font-style: normal;
}

body {
    background: @shark_teeth;
    font: normal 14px/1.5 'Dashboard UI', 'Lato', 'Helvetica Neue', 'Arial', sans-serif;
    -webkit-font-smoothing: antialiased;
    color: @title_grey;
    padding-top: 115px;
    text-rendering: optimizeLegibility;
}
.global-container {
    padding: 0 15px 0 90px;
}
.sidebar-settings-opened {
    padding: 0 15px 0 265px;
}

.main-title {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 50px;
    color: @title_grey;
}

.main-sub-title {
    font-size: 17px;
    font-weight: 400;
    color: @subtitle_grey;
    text-transform: uppercase;
    margin-bottom: 1.25em;
}

.slide-fade-enter-active, .slide-fade-right-enter-active,
.fadeIn-enter-active {
    transition: all .5s ease;
}

.slide-fade-right-enter-active {
    transition-delay: .2s;
}

.slide-fade-leave-active {
    transition: all .5s ease;
}

.slide-fade-right-leave-active, .fadeIn-leave-active {
    transition: .2s ease;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(15px);
    opacity: 0;
}

.slide-fade-right-enter, .slide-fade-right-leave-to {
    transform: translateX(15px);
    opacity: 0; 
}

.fadeIn-enter, .fadeIn-leave-to {
    opacity: 0;
}

.form-group {
    position: relative;
}

.tab-content>.active {
    outline: none;
}

.settings-divider {
    width: 100%;
    background: fade(#000, 10%);
    height: 1px;
    margin: 25px 0;
}

.sidebar-settings label:not(.custom-control-label), .sidebar-settings legend {
    font-size: 12px;
    font-weight: 700;
    color: #333D47;
}

.custom-control-label {
    cursor: pointer;
    color: @title_grey;
    font-weight: 700;
    font-size: 12px;
}

.custom-control-input:checked ~ .custom-control-label::before {
    border-color: @action_blue;
    background-color: @action_blue;
}

.form-control {
    border: 1px solid @border_grey_dark;

    &:focus {
        border: 1px solid @border_grey_dark;
        outline: none;  
        box-shadow: 0px 2px 4px @border_grey_dark;
    }

    &.form-control-sm {
        height: 31px;
        line-height: 31px;
    }   
}

.input-group-sm > .input-group-append > .input-group-text {
    font-size: 12px;
    font-weight: 700;
}

.input-group-sm > .form-control:not(textarea) {
    font-size: 13px;
    height: 31px;
    line-height: 31px;
}

.custom-select {
    font-size: 13px;

    &.custom-select-sm {
        height: 31px;
    }
}
.custom-select:focus {
    border-color: @border_grey_dark;
    box-shadow: 0px 2px 4px @border_grey_dark;
}

.btn-primary {
    background: @action_blue;
    border-color: @action_blue;
}

.input-group-append .input-group-text {
    background: @light_blue;
    color: @text_grey;
    border-color: @border_grey_dark;
    font-size: 14px;
}

.form-control {
    font-size: 13px;
}

.tooltip-inner {
    background-color: @title_grey;
    font-size: 13px;
    background: @shark_light;
    border-color: @shark_light;
    color: #fff;
}

.tooltip.show {
    opacity: 1;
}

.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
    border-top-color: @shark_light;
}

.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
    border-right-color: @shark_light;
}

.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
    border-bottom-color: @shark_light;
}

.sidebar-settings {
    .alignment-radios {
        display: flex;

        & > label {
            flex: 1;
            height: 31px;
            line-height: 31px;
            padding: 0;
            border-color: @border_grey_dark;
            background: @white;
            cursor: pointer;

            i {
                color: @text_grey;
            }

            &:hover, &:focus, &.active {
                background: @light_blue!important;
                border-color: @text_grey!important;
                outline: none;
                box-shadow: none;

                i {
                    color: @action_blue;
                }
            }
        }
    }
}

.preview-box {
    padding: 75px 15px;
    background: @white;
    border-radius: 0.25rem;
    margin: 0 auto;
    transition: width .15s ease-out;
    margin-bottom: 15px;
}

.table-hover tbody tr:hover {
    background-color: @border_grey;
}

.modal-title {
    color: @title_grey;
    font-weight: 400;
}

.modal-header {
    background: @shark_teeth;
    border-bottom: 1px solid @border_grey_medium;
}

.modal-footer {
   border-top: 1px solid @border_grey_medium; 
}

.no-overflow .modal-dialog-scrollable .modal-body {
    overflow-y: hidden;
}

.preview-box-fullsize-wrapper {
    min-height: 500px;
    min-height: 100vh;
}

.device-selector--large {
    font-size: 0;
    border: 1px solid @border_grey_dark;
    border-radius: .25rem;
    &.inline-style {
        display: inline-block;
        vertical-align: middle;
    }
    i {
        display: inline-block;
        width: 75px;
        height: 31px;
        line-height: 31px;
        background: #fff;
        text-align: center;
        font-size: 12px;
        cursor: pointer;

        &:first-child {
            border-radius: .25rem 0 0 .25rem;
            border-right: 1px solid @border_grey_medium;
        }

        &:last-child {
            border-radius: 0 .25rem .25rem 0;
            border-left: 1px solid @border_grey_medium;
        }

        &.active, &:hover {
            color: #fff;
            background: @action_blue;
        }
    }
}
.blocks-action-bar-inline {
    display: inline-block;
    position: relative;
    margin: 10px auto 30px;
}

.button-state-tabs .tab-content {
    padding: 30px 0;
}
.element-card {
    position: relative;
}
.pro-element {
    position: absolute;
    top: -1px;
    right: -1px;
    background: @action_orange;
    color: #fff;
    border-radius: .25rem;
    padding: 3px;
    line-height: 1;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
}

.pro-setting {
    position: relative;

    &:after {
        content: "\f005";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
        color: @action_orange;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 14px;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,.4);
        text-align: right;
    }

    &:hover:after {
        background: fade(@action_orange,15%);
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue